import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TimeTrackerWidget from './TimeTracker/TimeTrackerWidget';

const ConditionalTimeTracker = () => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Verificar si hay token
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);
  }, [location]);

  // Páginas públicas donde NO mostrar el widget
  const publicPaths = ['/', '/login', '/register', '/access-validation'];
  
  // No mostrar en páginas públicas
  if (publicPaths.includes(location.pathname) || location.pathname.startsWith('/register/')) {
    return null;
  }

  // No mostrar si no está autenticado
  if (!isAuthenticated) {
    return null;
  }

  // Mostrar el widget solo si está autenticado y no en página pública
  return <TimeTrackerWidget />;
};

export default ConditionalTimeTracker;

